import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div>\n  {{yield}}\n</div>",{ moduleName: "my-phorest/components/ui/form-layout/one-column-cards/-panel/-section.hbs" })